import React, { useRef, useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';

var isChildType = function isChildType(child, component) {
  try {
    var _child$type;

    if (component != null && component.displayName && child != null && (_child$type = child.type) != null && _child$type.displayName) {
      return component.displayName === child.type.displayName;
    }
  } catch (_unused) {
    console.error("Unable to match React children type");
  }

  return false;
};

// Reference https://www.npmjs.com/package/keycode-js
var KeyCode = {
  CODE_ENTER: 13,
  CODE_SPACE: 32,
  CODE_UP: 38,
  CODE_DOWN: 40,
  CODE_LEFT: 37,
  CODE_RIGHT: 39,
  CODE_ESCAPE: 27,
  CODE_DELETE: 46,
  CODE_TAB: 9,
  CODE_END: 35,
  CODE_HOME: 36,
  CODE_BACK_SPACE: 8
};

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/

var classnames = createCommonjsModule(function (module) {
/* global define */
(function () {

  var hasOwn = {}.hasOwnProperty;

  function classNames() {
    var classes = [];

    for (var i = 0; i < arguments.length; i++) {
      var arg = arguments[i];
      if (!arg) continue;
      var argType = typeof arg;

      if (argType === 'string' || argType === 'number') {
        classes.push(arg);
      } else if (Array.isArray(arg) && arg.length) {
        var inner = classNames.apply(null, arg);

        if (inner) {
          classes.push(inner);
        }
      } else if (argType === 'object') {
        for (var key in arg) {
          if (hasOwn.call(arg, key) && arg[key]) {
            classes.push(key);
          }
        }
      }
    }

    return classes.join(' ');
  }

  if ( module.exports) {
    classNames.default = classNames;
    module.exports = classNames;
  } else {
    window.classNames = classNames;
  }
})();
});

/* eslint-disable no-undefined,no-param-reassign,no-shadow */

/**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param  {number}    delay -          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {boolean}   [noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
 *                                    the internal counter is reset).
 * @param  {Function}  callback -       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                    to `callback` when the throttled-function is executed.
 * @param  {boolean}   [debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
 *                                    schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function}  A new, throttled, function.
 */
function throttle(delay, noTrailing, callback, debounceMode) {
  /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */
  var timeoutID;
  var cancelled = false; // Keep track of the last time `callback` was executed.

  var lastExec = 0; // Function to clear existing timeout

  function clearExistingTimeout() {
    if (timeoutID) {
      clearTimeout(timeoutID);
    }
  } // Function to cancel next exec


  function cancel() {
    clearExistingTimeout();
    cancelled = true;
  } // `noTrailing` defaults to falsy.


  if (typeof noTrailing !== 'boolean') {
    debounceMode = callback;
    callback = noTrailing;
    noTrailing = undefined;
  }
  /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */


  function wrapper() {
    for (var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++) {
      arguments_[_key] = arguments[_key];
    }

    var self = this;
    var elapsed = Date.now() - lastExec;

    if (cancelled) {
      return;
    } // Execute `callback` and update the `lastExec` timestamp.


    function exec() {
      lastExec = Date.now();
      callback.apply(self, arguments_);
    }
    /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */


    function clear() {
      timeoutID = undefined;
    }

    if (debounceMode && !timeoutID) {
      /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`.
       */
      exec();
    }

    clearExistingTimeout();

    if (debounceMode === undefined && elapsed > delay) {
      /*
       * In throttle mode, if `delay` time has been exceeded, execute
       * `callback`.
       */
      exec();
    } else if (noTrailing !== true) {
      /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */
      timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
  }

  wrapper.cancel = cancel; // Return the wrapper function.

  return wrapper;
}

var Tab = function Tab(_ref) {
  var id = _ref.id,
      selectedKey = _ref.selectedKey,
      _onClick = _ref.onClick,
      _onKeyDown = _ref.onKeyDown,
      label = _ref.label,
      subLabel = _ref.subLabel,
      newLabel = _ref.newLabel,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      focusedKey = _ref.focusedKey,
      isFocused = _ref.isFocused,
      tabIconComponent = _ref.tabIconComponent;
  var ref = useRef(null);
  var isSelected = id === selectedKey;
  useEffect(function () {
    if (isFocused && id === focusedKey && ref.current !== null) {
      ref.current.focus();
    }
  }, [isFocused, focusedKey, id]);
  return /*#__PURE__*/React.createElement("a", {
    ref: ref,
    className: className + " " + (isSelected ? activeClassName : ""),
    href: "#" + id,
    role: "tab",
    tabIndex: isSelected ? 0 : -1,
    onClick: function onClick(e) {
      return _onClick(e, id);
    },
    onKeyDown: function onKeyDown(e) {
      return _onKeyDown(e);
    }
  }, tabIconComponent && tabIconComponent, /*#__PURE__*/React.createElement("span", null, label, newLabel && /*#__PURE__*/React.createElement("strong", null, newLabel)), subLabel && /*#__PURE__*/React.createElement("span", null, subLabel));
};

Tab.displayName = "Tab";
Tab.propTypes = {
  selectedKey: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  activeClassName: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
  isFocused: PropTypes.bool.isRequired,
  subLabel: PropTypes.string,
  newLabel: PropTypes.string,
  focusedKey: PropTypes.string,
  tabIconComponent: PropTypes.any
};
Tab.defaultProps = {
  selectedKey: undefined,
  subLabel: null,
  newLabel: null,
  focusedKey: null,
  tabIconComponent: null
};

var modules_fef6bb00 = {"tabs":"TabList_module_tabs__ece03e5b","tab":"TabList_module_tab__ece03e5b","icon":"TabList_module_icon__ece03e5b","active":"TabList_module_active__ece03e5b","tabsWrapper":"TabList_module_tabsWrapper__ece03e5b"};

var TabList = function TabList(_ref) {
  var _cx, _cx2;

  var data = _ref.data,
      selectedKey = _ref.selectedKey,
      onClick = _ref.onClick,
      onKeyDown = _ref.onKeyDown,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      tabClassName = _ref.tabClassName,
      isFocused = _ref.isFocused,
      focusedKey = _ref.focusedKey,
      tabsWrapperClassName = _ref.tabsWrapperClassName,
      tabsRightButtonClassName = _ref.tabsRightButtonClassName,
      tabsLeftButtonClassName = _ref.tabsLeftButtonClassName,
      tabIconLeftComponent = _ref.tabIconLeftComponent,
      tabIconRightComponent = _ref.tabIconRightComponent;
  var ref = useRef(null);

  var _useState = useState(true),
      hideButtons = _useState[0],
      setHideButtons = _useState[1];

  var _useState2 = useState(true),
      disableLeftButton = _useState2[0],
      setDisableLeftButton = _useState2[1];

  var _useState3 = useState(true),
      disableRightButton = _useState3[0],
      setDisableRightButton = _useState3[1];

  var updateButtons = function updateButtons() {
    var _ref$current = ref.current,
        scrollLeft = _ref$current.scrollLeft,
        scrollWidth = _ref$current.scrollWidth,
        clientWidth = _ref$current.clientWidth;

    if (scrollWidth > clientWidth) {
      setHideButtons(false);
    } else {
      setHideButtons(true);
    }

    if (scrollLeft === 0) {
      setDisableLeftButton(true);
    } else {
      setDisableLeftButton(false);
    }

    if (scrollLeft + clientWidth >= scrollWidth) {
      setDisableRightButton(true);
    } else {
      setDisableRightButton(false);
    }
  };

  function sideScroll(element, direction, speed, distance, step) {
    var scrollAmount = 0;
    var slideTimer = setInterval(function () {
      if (direction === "left") {
        // eslint-disable-next-line no-param-reassign
        element.scrollLeft -= step;
      } else {
        // eslint-disable-next-line no-param-reassign
        element.scrollLeft += step;
      }

      scrollAmount += step;
      updateButtons();

      if (scrollAmount >= distance) {
        window.clearInterval(slideTimer);
      }
    }, speed);
  }

  useEffect(function () {
    updateButtons();
    return function () {};
  }, [ref]);
  useEffect(function () {
    var handleResize = throttle(200, function () {
      updateButtons();
    });
    window.addEventListener("resize", handleResize);
    return function () {
      window.removeEventListener("resize", handleResize);
    };
  });

  if (!data.length) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: classnames(modules_fef6bb00.tabsWrapper, (_cx = {}, _cx[tabsWrapperClassName] = tabsWrapperClassName, _cx))
  }, !hideButtons && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: tabsLeftButtonClassName,
    disabled: disableLeftButton,
    onClick: function onClick() {
      sideScroll(ref.current, "left", 25, 150, 10);
    }
  }, tabIconLeftComponent || "‹"), /*#__PURE__*/React.createElement("div", {
    role: "tablist",
    className: classnames(modules_fef6bb00.tabs, (_cx2 = {}, _cx2[className] = className, _cx2)),
    ref: ref,
    onScroll: function onScroll() {
      updateButtons();
    }
  }, data.map(function (tab) {
    var _cx3;

    var id = tab.eventKey;
    return /*#__PURE__*/React.createElement(Tab, {
      key: id,
      id: id,
      label: tab.label,
      subLabel: tab.subLabel,
      newLabel: tab.newLabel,
      icon: tab.icon,
      selectedKey: selectedKey,
      onClick: onClick,
      onKeyDown: onKeyDown,
      activeClassName: classnames(activeClassName, modules_fef6bb00.active),
      className: classnames(modules_fef6bb00.tab, (_cx3 = {}, _cx3[tabClassName] = tabClassName, _cx3)),
      focusedKey: focusedKey,
      isFocused: isFocused,
      tabIconComponent: tab.tabIcon
    });
  })), !hideButtons && /*#__PURE__*/React.createElement("button", {
    type: "button",
    disabled: disableRightButton,
    className: tabsRightButtonClassName,
    onClick: function onClick() {
      sideScroll(ref.current, "right", 25, 150, 10);
    }
  }, tabIconRightComponent || "›"));
};

TabList.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedKey: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  activeClassName: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  tabClassName: PropTypes.string.isRequired,
  isFocused: PropTypes.bool.isRequired,
  focusedKey: PropTypes.string,
  tabIconLeftComponent: PropTypes.any,
  tabIconRightComponent: PropTypes.any,
  tabsWrapperClassName: PropTypes.string,
  tabsRightButtonClassName: PropTypes.string,
  tabsLeftButtonClassName: PropTypes.string
};
TabList.defaultProps = {
  selectedKey: undefined,
  tabsWrapperClassName: "",
  tabsRightButtonClassName: "",
  tabsLeftButtonClassName: "",
  focusedKey: null,
  tabIconLeftComponent: null,
  tabIconRightComponent: null
};

var Panel = function Panel(_ref) {
  var children = _ref.children,
      id = _ref.id,
      selectedKey = _ref.selectedKey;
  var isSelected = id === selectedKey;
  return isSelected ? /*#__PURE__*/React.createElement("section", {
    "aria-hidden": !isSelected,
    style: {
      opacity: 1,
      display: "block"
    },
    id: id,
    role: "tabpanel",
    tabIndex: isSelected ? 0 : -1
  }, children) : /*#__PURE__*/React.createElement("section", {
    "aria-hidden": !isSelected,
    style: {
      opacity: 0,
      display: "none",
      position: "absolute"
    },
    id: id,
    role: "tabpanel",
    tabIndex: -1
  }, children);
};

Panel.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  id: PropTypes.string.isRequired,
  selectedKey: PropTypes.string
};
Panel.defaultProps = {
  selectedKey: undefined
};

var Panels = function Panels(_ref) {
  var data = _ref.data,
      selectedKey = _ref.selectedKey,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, data.map(function (panel) {
    return /*#__PURE__*/React.createElement(Panel, {
      key: panel.eventKey,
      id: panel.eventKey,
      selectedKey: selectedKey
    }, panel.content);
  }));
};

Panels.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedKey: PropTypes.string,
  className: PropTypes.string
};
Panels.defaultProps = {
  className: "",
  selectedKey: undefined
};

var Tab$1 = function Tab() {
  return null;
};

Tab$1.displayName = "Tab";

var processTabData = function processTabData(children, tabIconComponents) {
  return React.Children.map(children, function (child, index) {
    if (isChildType(child, Tab$1)) {
      return {
        label: child.props.title,
        subLabel: child.props.subTitle,
        newLabel: child.props.newLabel,
        icon: child.props.icon,
        content: child.props.children,
        eventKey: child.props.eventKey,
        onCustomClick: child.props.onHandleCustomClick,
        tabIcon: tabIconComponents[index]
      };
    }

    return undefined;
  });
};

var Tabs = function Tabs(_ref) {
  var activeKey = _ref.activeKey,
      children = _ref.children,
      className = _ref.className,
      activeClassName = _ref.activeClassName,
      tabClassName = _ref.tabClassName,
      panelClassName = _ref.panelClassName,
      tabsWrapperClassName = _ref.tabsWrapperClassName,
      tabIconComponents = _ref.tabIconComponents,
      tabIconLeftComponent = _ref.tabIconLeftComponent,
      tabIconRightComponent = _ref.tabIconRightComponent;
  var data = useMemo(function () {
    return processTabData(children, tabIconComponents);
  }, [children, tabIconComponents]);

  var _useState = useState(false),
      initialized = _useState[0],
      setInitialized = _useState[1];

  var _useState2 = useState(activeKey),
      selectedKey = _useState2[0],
      setSelectedKey = _useState2[1];

  var _useState3 = useState(null),
      focusedKey = _useState3[0],
      setFocusedKey = _useState3[1];

  var _useState4 = useState(false),
      isFocused = _useState4[0],
      setIsFocused = _useState4[1];

  var setFocus = function setFocus(key) {
    setFocusedKey(key);
    setIsFocused(true);
  };

  var handleClick = function handleClick(e, key) {
    if (e) e.preventDefault(); // Execute custom onClick handler

    var isPropagated = true;
    data.filter(function (tabItem) {
      return tabItem.eventKey === key;
    }).forEach(function (tabItem) {
      if (typeof tabItem.onCustomClick === "function") {
        // Return false to disable switching tabs
        isPropagated = tabItem.onCustomClick(e);
      }
    });

    if (selectedKey === key || !isPropagated) {
      return;
    }

    setSelectedKey(key);
    setFocus(key);
  };

  var handleKeyDown = function handleKeyDown(e) {
    if (e.keyCode === KeyCode.CODE_LEFT || e.keyCode === KeyCode.CODE_RIGHT) {
      e.preventDefault();
    } else {
      return;
    }

    var length = data == null ? void 0 : data.length;
    var index = data.findIndex(function (item) {
      return item.eventKey === selectedKey;
    });
    var targetIndex;

    if (e.keyCode === KeyCode.CODE_LEFT && index > 0) {
      targetIndex = index - 1;
    } else if (e.keyCode === KeyCode.CODE_RIGHT && index < length - 1) {
      targetIndex = index + 1;
    } else {
      return;
    } // Handle tabbing accessibility; callback function must return true in order to set new tab active


    handleClick(e, data[targetIndex].eventKey);
  };

  var hashChangeHandler = function hashChangeHandler() {
    var newHash = window.location.hash.substring(1);

    if (newHash && data.find(function (tab) {
      return tab.eventKey === newHash;
    })) {
      setSelectedKey(newHash);
      handleClick(null, newHash);
      return true;
    }

    return false;
  };

  useEffect(function () {
    if (!hashChangeHandler()) {
      if (!activeKey && data) {
        var _data$;

        setSelectedKey((_data$ = data[0]) == null ? void 0 : _data$.eventKey);
      }
    }

    setInitialized(true);
    window.addEventListener("hashchange", hashChangeHandler);
    return function () {
      window.removeEventListener("hashchange", hashChangeHandler);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(function () {
    if (initialized && activeKey) {
      if (data.find(function (tab) {
        return tab.eventKey === activeKey;
      })) {
        setSelectedKey(activeKey);
      } else {
        var _data$2;

        setSelectedKey((_data$2 = data[0]) == null ? void 0 : _data$2.eventKey);
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [activeKey]);
  if (data.length === 0) return /*#__PURE__*/React.createElement(React.Fragment, null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabList, {
    data: data,
    selectedKey: selectedKey,
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    className: className,
    activeClassName: activeClassName,
    tabClassName: tabClassName,
    focusedKey: focusedKey,
    isFocused: isFocused,
    tabsWrapperClassName: tabsWrapperClassName,
    tabIconLeftComponent: tabIconLeftComponent,
    tabIconRightComponent: tabIconRightComponent
  }), /*#__PURE__*/React.createElement(Panels, {
    data: data,
    selectedKey: selectedKey,
    className: panelClassName
  }));
};

Tabs.defaultProps = {
  className: "",
  activeClassName: "",
  tabClassName: "",
  activeKey: undefined,
  panelClassName: "",
  tabsWrapperClassName: "",
  tabIconComponents: [],
  tabIconLeftComponent: undefined,
  tabIconRightComponent: undefined
};
Tabs.propTypes = {
  /**
   * Class that styles `<nav>` of tabs list.
   */
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,

  /**
   * Class that styles active tab
   */
  activeClassName: PropTypes.string,

  /**
   * Class that styles `<a>` of tabs list
   */
  tabClassName: PropTypes.string,

  /**
   * Class that styles `<div>` of panel wrapper
   */
  panelClassName: PropTypes.string,

  /**
   * The Tab, that will be active by default. If this value is not selected, then the first Tab will be active by default.
   */
  activeKey: PropTypes.string,
  tabsWrapperClassName: PropTypes.string,
  tabIconComponents: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node)]),
  tabIconLeftComponent: PropTypes.any,
  tabIconRightComponent: PropTypes.any
};
Tab$1.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  eventKey: PropTypes.string.isRequired,
  title: PropTypes.node.isRequired,
  icon: PropTypes.object
};
Tab$1.defaultProps = {
  icon: null
};

export default Tabs;
export { Tab$1 as Tab, Tabs };
//# sourceMappingURL=index.js.map
